import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

// Blog resimlerini import ediyoruz
import webTrendsImage from '../images/blog/web-trends-2024.png';
import mobileAppImage from '../images/blog/mobile-app-guide.png';
import ecommerceSeoImage from '../images/blog/ecommerce-seo.png';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  // Blog yazıları - gerçek resimlerle güncellenmiş
  const blogPosts = [
    {
      id: 1,
      title: "Web Geliştirme Trendleri 2024",
      excerpt: "2024 yılında web geliştirme dünyasında öne çıkan trendleri ve teknolojileri keşfedin. Yapay zeka, PWA, WebAssembly ve daha fazlası.",
      content: `
        <h2>Web Geliştirme Dünyasında 2024 Trendleri</h2>
        <p>Web geliştirme dünyası sürekli olarak değişiyor ve gelişiyor. 2024 yılında öne çıkan trendler, geliştiricilerin ve işletmelerin dikkat etmesi gereken önemli konuları içeriyor.</p>
        
        <h3>1. Yapay Zeka Entegrasyonu</h3>
        <p>Yapay zeka teknolojileri web geliştirmede giderek daha fazla yer alıyor. Chatbot'lar, kişiselleştirilmiş içerik önerileri ve otomatik kod üretimi gibi alanlarda AI kullanımı artıyor.</p>
        
        <h3>2. Progressive Web Apps (PWA)</h3>
        <p>PWA'lar, native uygulamaların performansını web teknolojileriyle birleştiriyor. Offline çalışabilme, push notification ve app store'larda yer alma gibi özellikler sunuyor.</p>
        
        <h3>3. WebAssembly (WASM)</h3>
        <p>WebAssembly, web tarayıcılarında yüksek performanslı kod çalıştırmaya olanak sağlıyor. C++, Rust gibi dillerde yazılan kodları web'de çalıştırabiliyor.</p>
        
        <h3>4. Micro-Frontend Mimarisi</h3>
        <p>Büyük uygulamaları küçük, bağımsız parçalara bölerek geliştirme sürecini hızlandırıyor ve bakımı kolaylaştırıyor.</p>
        
        <h3>5. Edge Computing</h3>
        <p>Sunucu tarafı işlemleri kullanıcıya daha yakın konumlarda gerçekleştirerek performansı artırıyor ve gecikmeyi azaltıyor.</p>
        
        <p>Bu trendler, web geliştirme sürecini daha verimli ve kullanıcı dostu hale getiriyor. Mobilinfo olarak, bu teknolojileri projelerimizde aktif olarak kullanıyor ve müşterilerimize en iyi çözümleri sunuyoruz.</p>
      `,
      slug: "web-gelistirme-trendleri-2024",
      image: webTrendsImage,
      author: "Mobilinfo Ekibi",
      publishDate: "2024-01-15",
      readTime: "5 dk",
      tags: ["Web Geliştirme", "Trendler", "Teknoloji"]
    },
    {
      id: 2,
      title: "Mobil Uygulama Geliştirme Rehberi",
      excerpt: "Başarılı mobil uygulama geliştirmek için bilmeniz gereken temel prensipler ve ipuçları. Platform seçimi, UX tasarımı ve performans optimizasyonu.",
      content: `
        <h2>Mobil Uygulama Geliştirme Rehberi</h2>
        <p>Mobil uygulama geliştirme süreci karmaşık görünse de, doğru yaklaşımla başarılı sonuçlar elde edebilirsiniz. İşte dikkat etmeniz gereken temel noktalar:</p>
        
        <h3>1. Platform Seçimi</h3>
        <p>iOS, Android veya her ikisi için geliştirme yapacağınıza karar verin. Cross-platform çözümler (React Native, Flutter) zaman ve maliyet tasarrufu sağlayabilir.</p>
        
        <h3>2. Kullanıcı Deneyimi (UX) Tasarımı</h3>
        <p>Kullanıcıların ihtiyaçlarını anlayın ve basit, sezgisel bir arayüz tasarlayın. Mobil cihazlarda parmakla dokunma ve kaydırma hareketlerini optimize edin.</p>
        
        <h3>3. Performans Optimizasyonu</h3>
        <p>Uygulamanızın hızlı açılması ve sorunsuz çalışması için performans optimizasyonu yapın. Gereksiz veri kullanımından kaçının.</p>
        
        <h3>4. Güvenlik</h3>
        <p>Kullanıcı verilerini koruyun, güvenli API'ler kullanın ve veri şifreleme uygulayın.</p>
        
        <h3>5. Test Süreci</h3>
        <p>Farklı cihazlarda ve işletim sistemlerinde kapsamlı testler yapın. Beta testleri ile gerçek kullanıcı geri bildirimlerini alın.</p>
        
        <p>Mobilinfo olarak, bu prensipleri takip ederek müşterilerimize yüksek kaliteli mobil uygulamalar sunuyoruz.</p>
      `,
      slug: "mobil-uygulama-gelistirme-rehberi",
      image: mobileAppImage,
      author: "Mobilinfo Ekibi",
      publishDate: "2024-01-10",
      readTime: "8 dk",
      tags: ["Mobil Uygulama", "Geliştirme", "Rehber"]
    },
    {
      id: 3,
      title: "E-ticaret Sitesi Optimizasyonu",
      excerpt: "E-ticaret sitenizin performansını artırmak ve daha fazla satış yapmak için SEO stratejileri. Teknik SEO, içerik pazarlama ve yerel SEO.",
      content: `
        <h2>E-ticaret Sitesi SEO Optimizasyonu</h2>
        <p>E-ticaret sitelerinde SEO optimizasyonu, organik trafik artışı ve satış artışı için kritik önem taşır. İşte etkili stratejiler:</p>
        
        <h3>1. Teknik SEO</h3>
        <p>Site hızı, mobil uyumluluk, SSL sertifikası ve temiz URL yapısı gibi teknik faktörleri optimize edin.</p>
        
        <h3>2. Ürün Sayfası Optimizasyonu</h3>
        <p>Her ürün için benzersiz başlık, meta açıklama ve açıklayıcı içerik oluşturun. Yüksek kaliteli ürün fotoğrafları kullanın.</p>
        
        <h3>3. İçerik Pazarlama</h3>
        <p>Blog bölümü ile değerli içerikler üretin. Ürün rehberleri, kullanım kılavuzları ve sektörel makaleler yazın.</p>
        
        <h3>4. Yerel SEO</h3>
        <p>Fiziksel mağazanız varsa Google My Business profilinizi optimize edin ve yerel anahtar kelimeleri hedefleyin.</p>
        
        <h3>5. Kullanıcı Deneyimi</h3>
        <p>Kolay navigasyon, hızlı yükleme süreleri ve mobil uyumlu tasarım ile kullanıcı deneyimini iyileştirin.</p>
        
        <p>Bu stratejileri uygulayarak e-ticaret sitenizin görünürlüğünü artırabilir ve daha fazla müşteriye ulaşabilirsiniz.</p>
      `,
      slug: "e-ticaret-sitesi-optimizasyonu",
      image: ecommerceSeoImage,
      author: "Mobilinfo Ekibi",
      publishDate: "2024-01-05",
      readTime: "6 dk",
      tags: ["E-ticaret", "SEO", "Optimizasyon"]
    }
  ];

  useEffect(() => {
    const foundPost = blogPosts.find(p => p.slug === slug);
    if (foundPost) {
      setPost(foundPost);
    }
    setLoading(false);
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Yazı Bulunamadı</h1>
          <Link to="/blog" className="text-cyan-500 hover:text-cyan-600">
            Blog'a Dön
          </Link>
        </div>
      </div>
    );
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "description": post.excerpt,
    "image": post.image,
    "url": `https://mobilinfo.com.tr/blog/${post.slug}`,
    "datePublished": post.publishDate,
    "author": {
      "@type": "Organization",
      "name": post.author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Mobilinfo Bilgi Teknolojileri",
      "url": "https://mobilinfo.com.tr"
    }
  };

  return (
    <>
      <SEO
        title={`${post.title} - Mobilinfo Blog`}
        description={post.excerpt}
        keywords={post.tags.join(', ')}
        canonical={`/blog/${post.slug}`}
        ogImage={post.image}
        ogType="article"
        structuredData={structuredData}
      />
      
      <div>
        <NavBar />
      </div>
      
      <div className="min-h-screen bg-gray-50 pt-20">
        <div className="container mx-auto px-4 py-12">
          {/* Breadcrumb */}
          <nav className="mb-8" data-aos="fade-up">
            <ol className="flex items-center space-x-2 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-cyan-500">Ana Sayfa</Link></li>
              <li>/</li>
              <li><Link to="/blog" className="hover:text-cyan-500">Blog</Link></li>
              <li>/</li>
              <li className="text-gray-900">{post.title}</li>
            </ol>
          </nav>

          {/* Article Header */}
          <header className="mb-12" data-aos="fade-up">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                {post.title}
              </h1>
              
              <div className="flex items-center text-gray-600 mb-6">
                <span>{post.publishDate}</span>
                <span className="mx-2">•</span>
                <span>{post.readTime} okuma</span>
                <span className="mx-2">•</span>
                <span>{post.author}</span>
              </div>
              
              <div className="flex flex-wrap gap-2 mb-8">
                {post.tags.map((tag, index) => (
                  <span 
                    key={index}
                    className="px-3 py-1 bg-cyan-100 text-cyan-800 text-sm rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              
              <img 
                src={post.image} 
                alt={post.title}
                className="w-full h-64 md:h-96 object-cover rounded-lg"
              />
            </div>
          </header>

          {/* Article Content */}
          <article className="max-w-4xl mx-auto" data-aos="fade-up">
            <div 
              className="prose prose-lg max-w-none"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
          </article>

          {/* Related Posts */}
          <section className="mt-16" data-aos="fade-up">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              İlgili Yazılar
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts
                .filter(p => p.id !== post.id)
                .slice(0, 3)
                .map((relatedPost, index) => (
                  <article 
                    key={relatedPost.id}
                    className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <div className="aspect-w-16 aspect-h-9">
                      <img 
                        src={relatedPost.image} 
                        alt={relatedPost.title}
                        className="w-full h-48 object-cover"
                      />
                    </div>
                    
                    <div className="p-6">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                        <Link 
                          to={`/blog/${relatedPost.slug}`}
                          className="hover:text-cyan-500 transition-colors"
                        >
                          {relatedPost.title}
                        </Link>
                      </h3>
                      
                      <p className="text-gray-600 mb-4 line-clamp-3">
                        {relatedPost.excerpt}
                      </p>
                      
                      <Link 
                        to={`/blog/${relatedPost.slug}`}
                        className="inline-flex items-center text-cyan-500 hover:text-cyan-600 font-medium"
                      >
                        Devamını Oku
                        <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </Link>
                    </div>
                  </article>
                ))}
            </div>
          </section>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default BlogPost; 